module.exports = __webpack_public_path__ + "img/left.1fcf7ce2.png";